import { Listbox } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledListbox = styled(Listbox)`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: 0.875rem;

  button {
    padding: 0.75rem 0;
    border-radius: 1px;
  }
  p {
    font-size: 0.875rem;
    line-height: 1.125rem;
    margin-bottom: 0;
  }
  svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.5rem;
    vertical-align: middle;
  }
  ul {
    min-width: auto;
  }

  label {
    display: none;
  }
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  div[role='combobox'] {
    ul {
      width: fit-content;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      margin-top: 0;
    }
  }
`;
